const accountTabs = [
  {
    name: 'biodataConfiguration',
    label: 'Biodata Configuration',
    path: '/settings/biodata-config',
  },
];

export default accountTabs;
